/**
 * CLK PDP custom features:
 * - Quantity SubTotal (variant-aware)
 * - Hide empty Specification label rows
 */
(function () {
  'use strict';

  function getConfig() {
    return window.__clkPdp || {};
  }

  function formatMoney(cents) {
    var config = getConfig();
    var amount = (Number(cents) || 0) / 100;
    var dollars = amount.toFixed(2);

    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function' && config.moneyFormat) {
      try {
        return Shopify.formatMoney(cents, config.moneyFormat);
      } catch (e) {
        /* fall through */
      }
    }

    var symbol = config.currencySymbol || '$';
    return symbol + dollars;
  }

  function parseVariantPrices() {
    var el = document.getElementById('clk-pdp-variant-prices');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

  function getSelectedVariantId(root) {
    var form =
      (root && root.querySelector('[data-product-form], form[action*="/cart/add"]')) ||
      document.querySelector('.product-main [data-product-form], .product-main form[action*="/cart/add"]');
    if (!form) return null;

    var idInput = form.querySelector('input[name="id"], select[name="id"]');
    if (!idInput) return null;
    return idInput.value || null;
  }

  function getUnitPriceCents(root) {
    var prices = parseVariantPrices();
    var variantId = getSelectedVariantId(root);
    if (variantId && prices[variantId] != null) {
      return parseInt(prices[variantId], 10) || 0;
    }

    var priceInput =
      (root && root.querySelector('.input_price, [data-clk-unit-price]')) ||
      document.querySelector('.product-main .input_price, .product-main [data-clk-unit-price]');
    if (!priceInput) return 0;
    return parseInt(String(priceInput.value).trim(), 10) || 0;
  }

  function syncHiddenUnitPrice(root, cents) {
    var priceInput =
      (root && root.querySelector('.input_price, [data-clk-unit-price]')) ||
      document.querySelector('.product-main .input_price, .product-main [data-clk-unit-price]');
    if (priceInput) {
      priceInput.value = String(cents);
    }
  }

  function initSubtotal() {
    var root = document.querySelector('.product-main') || document;
    var quantityInput = root.querySelector(
      '.quantity-selector__input, [data-quantity-input], .element-quantity-selector__input'
    );
    var priceDisplay = document.getElementById('code_div_price');
    if (!quantityInput || !priceDisplay) return;

    function updateSubtotal() {
      var quantity = parseInt(quantityInput.value, 10);
      if (!quantity || quantity < 1) {
        quantity = 1;
        quantityInput.value = '1';
      }

      var unitCents = getUnitPriceCents(root);
      syncHiddenUnitPrice(root, unitCents);
      var totalCents = unitCents * quantity;
      priceDisplay.textContent = 'SubTotal: ' + formatMoney(totalCents);
    }

    updateSubtotal();

    quantityInput.addEventListener('input', updateSubtotal);
    quantityInput.addEventListener('change', updateSubtotal);

    var qtyRoot = quantityInput.closest('[data-quantity-selector], quantity-selector, .quantity-selector');
    if (qtyRoot) {
      qtyRoot.addEventListener('click', function () {
        window.setTimeout(updateSubtotal, 0);
      });
    }

    var form =
      root.querySelector('[data-product-form], form[action*="/cart/add"]') ||
      document.querySelector('.product-main [data-product-form], .product-main form[action*="/cart/add"]');

    if (form) {
      form.addEventListener('change', updateSubtotal);
      var idField = form.querySelector('input[name="id"], select[name="id"]');
      if (idField) {
        idField.addEventListener('change', updateSubtotal);
      }
    }

    document.addEventListener('product:variant-change', updateSubtotal);
    document.addEventListener('variant:change', updateSubtotal);
  }

  function normalizeText(value) {
    return String(value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function segmentHasValue(segmentRoot) {
    var clone = segmentRoot.cloneNode(true);
    clone.querySelectorAll('strong, b').forEach(function (el) {
      el.remove();
    });
    if (normalizeText(clone.textContent)) return true;
    if (clone.querySelector('a[href], img, svg')) return true;
    return false;
  }

  function hideEmptyParagraph(p) {
    var labels = p.querySelectorAll('strong, b');
    if (!labels.length) return;

    // Single label row: hide when only the heading remains
    if (labels.length === 1 && !p.querySelector('br')) {
      if (!segmentHasValue(p)) {
        p.style.display = 'none';
      }
      return;
    }

    // Multi-label / <br>-separated rows: keep only rows that have values
    var parts = [];
    var currentNodes = [];

    function flush() {
      if (!currentNodes.length) return;
      var wrap = document.createElement('div');
      currentNodes.forEach(function (node) {
        wrap.appendChild(node);
      });
      if (segmentHasValue(wrap)) {
        parts.push(wrap.innerHTML);
      }
      currentNodes = [];
    }

    Array.prototype.slice.call(p.childNodes).forEach(function (node) {
      if (node.nodeName === 'BR') {
        flush();
      } else {
        currentNodes.push(node.cloneNode(true));
      }
    });
    flush();

    if (!parts.length) {
      p.style.display = 'none';
      return;
    }

    p.style.display = '';
    p.innerHTML = parts.join('<br>');
  }

  function hideEmptySpecRows() {
    var tabs = document.querySelectorAll('.collapsible-tab');

    tabs.forEach(function (tab) {
      var heading = tab.querySelector('.collapsible-tab__heading');
      if (!heading) return;
      if (normalizeText(heading.textContent) !== 'Specifications') return;

      var text = tab.querySelector('.collapsible-tab__text');
      if (!text) return;

      text.querySelectorAll('p').forEach(hideEmptyParagraph);
    });
  }

  function init() {
    initSubtotal();
    hideEmptySpecRows();

    document.querySelectorAll('.collapsible-tab').forEach(function (tab) {
      tab.addEventListener('toggle', function () {
        if (tab.open) hideEmptySpecRows();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
